import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import Api from '../api/Api';

const BannerContainer = styled.div`
  position: fixed;
  left: 15px;
  bottom: calc(env(safe-area-inset-bottom, 0px) + 5px);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 100000;
    width: 17%;
  @media (max-width: 768px) {
    width: 50%;
  }

`;

const AnnouncementBanner = styled.div`
  width: 100%;
  background: rgba(0,0,0,0.5);
  border-radius: 10px;
  padding: 10px;
  color: white;
  transition: all 0.3s ease;
  cursor: pointer;

  &.collapsed {
    padding: 10px;
    min-height: 50px;
    .content {
      display: none;
    }
  }

  &.hidden {
    display: none;
  }

  &:hover {
    background: rgba(0,0,0,0.7);
  }
`;

const BottomBanner = styled.div`
  background: ${props => props.hasItems ? 'rgba(0,0,0,0.5)' : 'rgba(0,0,0,0)'};
  border-radius: 10px;
  padding: 0px 7px 10px 7px;
  color: white;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;

  width : 100%  
  &.collapsed {
    padding: 10px;
    padding-bottom: calc(env(safe-area-inset-bottom, 10px) + 5px);
    min-height: 50px;
    .content {
      display: none;
    }
  }

  &.hidden {
    display: none;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -30px;
  left: 0px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0,0,0,0.5);
  border: none;
  color: white;
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;

  @media (max-width: 768px) {
    display: flex;
  }
`;

const ImageContent = ({items, currentItemIdx}) => {
  if (items[currentItemIdx] === undefined) {
    return <></>;
  }
  return (
    <>
    {items.length > 0 && (
    <div style={{
      width: '100%',
      height: '0', 
      paddingBottom: 'calc(218 / 336 * 100%)',
      position: 'relative',
      borderRadius: '10px',
    }}>
      <img 
        src={items[currentItemIdx].topImageUrl}
        alt="테스트 이미지"
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '10px'
        }}
      />
    </div>
    )}
    </>
  );
};

const TextContent = ({items, currentItemIdx, setCurrentItem}) => {
  if (items[currentItemIdx] === undefined) {
    return <></>;
  }
  return (<>
    <div style={{
      marginLeft: '7px',
              position: 'relative', 
              marginTop: '10px',
              color: 'white',
              padding: '0px 8px', 
              border: '1px solid white',
              borderRadius: '10px',
              fontSize: '20px',
              display: 'inline-block'
            }}>
              분양중
            </div>
    <div style={{
      marginLeft: '7px',
      marginTop: '5px', color: 'white', fontSize: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
      {items[currentItemIdx]["title"]}
      <PrevNextButton onPrev={() => {setCurrentItem(currentItemIdx - 1)}} onNext={() => {setCurrentItem(currentItemIdx  + 1)}} style={{width: 'fit-content'}} />

    </div>
  </>
  );
};

const PrevNextButton = ({onPrev, onNext}) => {
  return (
    <div style={{display: 'flex', gap: '10px', marginRight: '7px'}}>
      <div onClick={onPrev}>
        <FontAwesomeIcon icon={faChevronLeft} style={{color: 'white', cursor: 'pointer'}} />
      </div>
      <div onClick={onNext}>
        <FontAwesomeIcon icon={faChevronRight} style={{color: 'white', cursor: 'pointer'}} />
      </div>
    </div>
  );
};


const Banners = () => {
  const [currentItem, setCurrentItem] = useState(0);
  const [isCollapsed, ] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [, setProgress] = useState(0);
  const progressIntervalRef = useRef();
  const [items, setItems] = useState([]);

  //const items = ["천의바람", "장례식장", "추모관", "봉안당"];

  const fetchData = async () => {
    try {
      var ret = (await Api.hpSellingScan()).data;
      if (ret["ret"] === true){
        setItems(ret.items);
      }     
    } catch (error) {
      //setError(error);
    } finally {
      //setIsLoading(false);
    }
    startItemRotation();
  };

  
  useEffect(() => {
    fetchData();
    return () => {
      clearInterval(progressIntervalRef.current);
    };
  }, []);
  
  const startItemRotation = () => {
    if (items.length === 0) {
      return;
    }
    clearInterval(progressIntervalRef.current);

    progressIntervalRef.current = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          setCurrentItem(prev => (prev + 1) % items.length);
          return 0;
        }
        return prev + 1;
      });
    }, 50);

    return () => {
      clearInterval(progressIntervalRef.current);
    };
  };

  return (
    <BannerContainer>
      <AnnouncementBanner
        className={`${isCollapsed ? 'collapsed' : ''} ${isHidden ? 'hidden' : ''}`} 
        style={{textAlign: 'center'}}
        onClick={() => {
          if(window.confirm(
            '시안소식 페이지로 이동하시겠습니까?'
          )) {
            window.top.location.href = 'https://www.sianpark.co.kr/pg/bbs/board.php?bo_table=cs03'
          }
        }}
      >
        시안소식 바로가기
      </AnnouncementBanner>
      <BottomBanner 
        className={`${isCollapsed ? 'collapsed' : ''} ${isHidden ? 'hidden' : ''}`}
        hasItems={items.length > 0}
      >
        <div width="100%">
        <CloseButton onClick={() => setIsHidden(true)}>
          <FontAwesomeIcon icon={faTimes} size="sm" />
        </CloseButton>
        </div>
        {!isCollapsed && items.length > 0 && (
          <>
            <div className="content" style={{width: '100%'}}>
              <div style={{paddingLeft: '5px', paddingRight: '5px'}}> 
                <ImageContent items={items} currentItemIdx={currentItem} />
              </div>
              <TextContent 
                items={items} 
                currentItemIdx={currentItem} 
                setCurrentItem={(item) => {
                  if (item < 0) {
                    setCurrentItem(items.length - 1);
                  } else if (item >= items.length) {
                    setCurrentItem(0);
                  } else {
                    setCurrentItem(item);
                  }
                  startItemRotation();
                }}
              style={{ textAlign: 'left' }} 
              />
              </div>          
          </>
        )}
      </BottomBanner>
    </BannerContainer>
  );
};

export default Banners;
